import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const EnquiryPopup = () => {
    const [show, setShow] = useState(true);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                centered
                size="md"
                backdrop="static"
                keyboard={false}
            >
                <div
                    style={{
                        background: "#fae3e6ff",
                        color: "#000",
                        padding: "20px",
                        borderRadius: "10px",
                    }}
                >
                    <div className="d-flex justify-content-end">
                        <Button
                            variant="link"
                            onClick={handleClose}
                            style={{ color: "#000", fontSize: "20px", textDecoration: "none" }}
                        >
                            ✕
                        </Button>
                    </div>

                    <h3 className="text-center fw-bold" style={{ color: "var(--main-color)" }}>
                        100% JOB ORIENTED
                    </h3>
                    <h4 className="text-center fw-bold" style={{ color: "var(--main-color)" }}>
                        6-MONTH'S PROGRAM
                    </h4>
                    <hr style={{ borderColor: "var(--main-color)" }} />

                    <p className="text-center fw-bold">YOUR CAREER, OUR COMMITMENT !</p>
                    <p className="text-center">
                        Enroll in Our Advanced Certification Programs & Launch Your Career
                        with Leading Companies!
                    </p>

                    <ul className="list-unstyled row ps-0">
                        <li className="col-6 d-flex align-items-center mb-2">
                            <span className="check-icon me-2">
                                <i className="bi bi-check"></i>
                            </span> Assured Job Placement
                        </li>
                        <li className="col-6 d-flex align-items-center mb-2">
                            <span className="check-icon me-2">
                                <i className="bi bi-check"></i>
                            </span> Industry-Expert Trainers
                        </li>
                        <li className="col-6 d-flex align-items-center mb-2">
                            <span className="check-icon me-2">
                                <i className="bi bi-check"></i>
                            </span> Money-Back Promise
                        </li>
                        <li className="col-6 d-flex align-items-center mb-2">
                            <span className="check-icon me-2">
                                <i className="bi bi-check"></i>
                            </span> Limited Seats Only
                        </li>
                    </ul>

                    <p className="fw-bold text-center mt-3">
                        WANT TO UNDERSTAND THE PROGRAM BENEFITS?
                    </p>
                    <p className="text-center">
                        Fill the Form & Our Counselor Will Call You Back Shortly!
                    </p>

                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Control type="text" placeholder="Your Name" className="w-75 m-auto" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Control type="text" placeholder="Mobile Number" className="w-75 m-auto" />
                        </Form.Group>

                        <Button className="btn-grad1 border-0 w-75 " size="sm">
                            CALL ME BACK NOW                                              </Button>
                    </Form>
                </div>
            </Modal>


        </>
    );
};

export default EnquiryPopup;
